import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder, Validators, FormArray } from '@angular/forms';
import * as _ from 'lodash';
import { JsonPipe } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatGridListModule } from '@angular/material/grid-list';

@Component({
    selector: 'app-calendar-picker',
    templateUrl: './calendar-picker.component.html',
    styleUrls: ['./calendar-picker.component.scss'],
    standalone: true,
    imports: [
        MatGridListModule,
        MatDatepickerModule,
        JsonPipe,
    ],
})
export class calendarPickerComponent implements OnInit {
    constructor(private ref: ChangeDetectorRef, private fb: UntypedFormBuilder) { this.onSelect(this.selectedDate);}

    selectedDate = new Date('2019/09/26');
    startAt = new Date('2019/09/11');
    minDate = new Date('2019/09/14');
    maxDate = new Date(new Date().setMonth(new Date().getMonth() + 1));
    year: any;
    DayAndDate: string;


    @Input() baseForm;

    @Input() rangeData;

    range =  this.fb.group({
        start: [],
        end: []
      });

    ngOnInit(): void {
    }



    onSelect(event) {
        this.selectedDate = event;
        const dateString = event.toDateString();
        const dateValue = dateString.split(' ');
        this.year = dateValue[3];
        this.DayAndDate = dateValue[0] + ',' + ' ' + dateValue[1] + ' ' + dateValue[2];
      }

      dateFilter = (d: Date): boolean => {
        const day = d.getDay();
        // Prevent Saturday and Sunday from being selected.
        return day !== 0 && day !== 6 ;
      }

      //filter out non-work days and or booked days
      rangeFilter(date: Date): boolean {
        return date.getDate() > 3 || date.getDay() ==2;
      }
}
